import { render, staticRenderFns } from "./SubmitResources.vue?vue&type=template&id=61e4cb27&scoped=true&"
import script from "./SubmitResources.vue?vue&type=script&lang=js&"
export * from "./SubmitResources.vue?vue&type=script&lang=js&"
import style0 from "./SubmitResources.vue?vue&type=style&index=0&id=61e4cb27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e4cb27",
  null
  
)

export default component.exports